// Configuration for the development environment. Angular swaps this file in via the
// fileReplacements entry for each build configuration in angular.json.
import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  "80002": {
    "EXPLORER": "https://www.oklink.com/amoy",
    "PROVIDER": "https://rpc-amoy.polygon.technology",
    "PROVIDERS": [
      "https://polygon-amoy.g.alchemy.com/v2/Fad0zhYYtcsOt7RzhxJw5_YzZWKjaue6",
      "https://polygon-amoy.infura.io/v3/87894195c22d497195974e3dfecda9db",
      "https://lb.drpc.live/polygon-amoy/Auz3ZAt_kE-AjENU_fJuBBMshWuqcQAR77UiMnlAuwl_"
    ],
    "CHAIN_NETWORK": "0x13882",
    "CHAINID": 80002,
    "CURRENCY_NAME": "MATIC",
    "CURRENCY_SYMBOL": "MATIC",
    "CHAIN_NAME": "Polygon Testnet",
    "FACTORY_ADDRESS": "0x12ba55372ec48125e35dE6b0a84866b681276Bf7",
    "ACCESS_CONTROL_TOKEN": "0xDDE9256778596E949DEa33912c82312B1cd4066C",
    "INTRODUCER_CONTRACT_ADDRESS": "0x09492ef585E6920FcdDe384ceBC5a8a566F6f6e8",
    "NFT_LOAN_CONTRACT_TEST": "0x94c9Fc969F2D83B95CEeD4B5Ce503BB14aB93200",
    "NFT_LOAN_CONTRACT_DEV": "0xdAf8940bc70e121D22657Ae91920e5FD984aC290",
    "BORROW_LEND_CONTRACT": "0x27cB8E823B7e357B62DE0B4985dbf3261fAbEd51",
    "EXCHANGE_CONTRACT": "0xE986659879107F408325120D0a154910545079C2"
  },
  "production": false,
  "development": true,
  "staging": false,
  "preproduction": false,
  "envName": "development",
  "CHAIN_ID": "0x13882",
  "BASE_URL": "https://chocolate-magnificent-blackbird-410.mypinata.cloud/ipfs/",
  "SOCKET_ENDPOINT": "https://devapi.realworld.fi",
  "FILE_PATH": "",
  "API_BASE_URL": "https://devapi.realworld.fi/api/v1/",
  "API_BASE_URL_V2": "https://devapi.realworld.fi/api/v2/",
  "API_BASE_URL_V3": "https://devapi.realworld.fi/api/v3/",
  "IP_INFO_BASE": "https://ipinfo.io/",
  "SUPPORTED_CHAINS": [
    "80002"
  ],
  "DEFAULT_NETWORK": "80002",
  "DEFAULT_CHAIN": "0x13882",
  "MARKETPLACE_URL": "https://devmarket.realworld.fi/",
  "WEB_SITE_URL": "https://devapp.realworld.fi",
  "WALLET_CONNECT_PROJECT_ID": "b6c201630414d0fd586cfc6add82cde7",
  "TRANSACTION_HASH_EXPLORER": "https://amoy.polygonscan.com",
  "SUB_ADMIN_EMAIL": "developmentrealworld@yopmail.com",
  "POL_TREASURY_WALLET": "0x9ceA092054283695e50837d5C304B565D22E8AF2",
  "AUTO_LOGOUT_DURATION": 21600,
  "AUTO_LOGOUT_TIMEOUT": 30,
  "ENABLE_TELEGRAM_ERROR_ALERTS": true,
  "TELEGRAM_TRACK_TOAST_ERRORS": true,
  "ipInfoBase": "https://ipinfo.io/"
} as AppEnvironment;
